import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  getAssetAlert() {
    return axios.get('/v1/featurenotification/get-asset-alert-notification/')
  },
})
